<template>
  <div class="primaryPromotion">
    <div class="primaryPromotion_top">
      <div class="top_title">
        <h3 class="title">原生推广页</h3>
        <i
          class="icon"
          @click="$emit('close')"
        >X</i>
      </div>
      <div class="top_tips">
        <span class="text">以下是适用于 推广品牌活动 的原生推广页</span>
        <span class="text">如需修改，请在 推广页管理 中复制推广页修改</span>
      </div>
      <div class="top_buttonArea">
        <div class="top_buttonArea_left">
          <el-input
            v-model="input"
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
          />
        </div>
        <div class="top_buttonArea_right">
          <button class="right_button">
            <i class="el-icon-s-help" />
            <span class="button_text">刷新</span>
          </button>

          <el-button icon="el-icon-s-tools">推广页管理</el-button>

          <el-button icon="el-icon-plus">新建推广页</el-button>
        </div>
      </div>
    </div>
    <div class="primaryPromotion_main">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
        />
        <el-table-column
          label="日期"
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.date }}</template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          width="120"
        />
        <el-table-column
          prop="address"
          label="地址"
          show-overflow-tooltip
        />
      </el-table>
    </div>
    <div class="primaryPromotion_buttonArea">
      <el-button>取消</el-button>
      <el-button type="success">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
.primaryPromotion {
  display: flex;
  width: 860px;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 0 1px hsla(0, 0%, 42%, 0.15), 0 10px 36px 0 rgba(0, 0, 0, 0.1), 0 6px 15px 0 rgba(0, 0, 0, 0.07);
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 510px;
  .primaryPromotion_top {
    position: relative;
    padding: 20px 24px 16px;
    min-height: 64px;
    background-color: #fff;
    border-radius: 10px 10px 0 0;
    .top_title {
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 16px;
        line-height: 24px;
        color: #1f1f1f;
        font-weight: 600;
      }
      .icon {
        font-style: normal;
        font-size: 17px;
        cursor: pointer;
      }
    }

    .top_tips {
      padding: 10px 0px;
      display: flex;
      justify-content: space-between;
      .text {
      }
    }

    .top_buttonArea {
      display: flex;
      justify-content: space-between;
      .top_buttonArea_left {
      }
      .top_buttonArea_right {
        .right_button {
          outline: none;
          background-color: transparent;
          border: none;
          height: 100%;
          padding: 0px 9px;
          border-radius: 4px;
          cursor: pointer;
          margin: 0px 10px;
          &:hover {
            background-color: #e9e9e9;
          }
          .button_text {
            display: inline-block;
            margin-left: 5px;
          }
        }
      }
    }
  }

  .primaryPromotion_main {
    /* padding: 0px 20px; */
    flex-grow: 1;
    padding-top: 1px;
    box-shadow: inset 0 1px 0 0 rgb(0 0 0 / 6%);
  }

  .primaryPromotion_buttonArea {
    height: 78px;
    background-color: #fff;
    border-radius: 0 0 10px 10px;
    box-shadow: inset 0 1px 0 0 rgb(0 0 0 / 6%);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
